import { apiCreate, apiGetOne, apiGetList } from './ApiBaseActions';
export const API_GET_LIST_CLIENT_SEMINAR = 'API_GET_LIST_CLIENT_SEMINAR';
export const API_GET_ONE_CLIENT_SEMINAR = 'API_GET_ONE_CLIENT_SEMINAR';
export const API_GET_ONE_CLIENT_SEMINAR_SUCCESS = 'API_GET_ONE_CLIENT_SEMINAR_SUCCESS';
export const API_CREATE_CLIENT_SEMINAR_VIEW = 'API_CREATE_CLIENT_SEMINAR_VIEW';
export const API_CREATE_CLIENT_SEMINAR_DOCUMENT_PAGE_VIEW = 'API_CREATE_CLIENT_SEMINAR_DOCUMENT_PAGE_VIEW';
export const API_CREATE_CLIENT_SEMINAR_REQUEST = 'API_CREATE_CLIENT_SEMINAR_REQUEST';
/**
 * セミナー一覧の取得
 * @deprecated TS化済 src/actions/SeminarActions/getList.ts
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetListClientSeminar = (params, meta) => apiGetList(API_GET_LIST_CLIENT_SEMINAR, '/seminar/search', params, meta || {});
/**
 * セミナーの取得
 * @param id
 * @param meta
 * @returns {*}
 */
export const apiGetOneClientSeminar = (id, meta) => apiGetOne(API_GET_ONE_CLIENT_SEMINAR, `/seminar/${id}/show`, Object.assign({}, meta));
/**
 * セミナー閲覧ログ作成
 * @param id
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiCreateClientSeminarView = (id, params, meta) => apiCreate(API_CREATE_CLIENT_SEMINAR_VIEW, `/seminar/search/history/${id}`, params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナー申し込みの作成
 * @param id
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiCreateClientSeminarRequest = (id, params, meta) => apiCreate(API_CREATE_CLIENT_SEMINAR_REQUEST, `/seminar/${id}/request`, params, Object.assign(Object.assign({}, params), meta));
/**
 * セミナー資料画像の閲覧ログ保存の実行
 * @param id
 * @param page
 * @param viewId
 * @param meta
 * @returns {*}
 */
export const apiCreateClientSeminarDocumentPageView = (id, page, viewId, meta) => apiCreate(API_CREATE_CLIENT_SEMINAR_DOCUMENT_PAGE_VIEW, `/seminar/${id}/page/${page}/${viewId || ''}`, {}, Object.assign({}, (meta || {})));
